import { useLocation } from '@online-webinar/router';

const inSection = { className: 'active', 'aria-current': 'true' } as const;

/**
 * `inactiveProps` for the "Webinar overview" menu link, which points to /upcoming. On /on-demand, the other tab of the
 * same overview, the link is marked as the current section: active style and aria-current="true" (on /upcoming the
 * router's Link marks it as the current page itself). The home page only shows a selection, so it is not part of it.
 */
export const useScheduleSectionProps = () => (useLocation().pathname === '/on-demand' ? inSection : undefined);
